
import { defineComponent } from 'vue';
import { abreWhatsApp } from '@/uteis/contato';

// Percentual estimado de economia da conta de luz com energia solar
const PERCENTUAL_ECONOMIA = 0.9;

export default defineComponent({
    name: 'SimuladorSolar',
    data() {
        return {
            conta: null as number | null,
            PERCENTUAL_ECONOMIA
        };
    },
    computed: {
        contaValida(): boolean {
            return typeof this.conta === 'number' && this.conta >= 50;
        },
        economiaMensal(): number {
            return (this.conta ?? 0) * PERCENTUAL_ECONOMIA;
        }
    },
    methods: {
        formatar(valor: number): string {
            // valores grandes viram "R$ 270 mil" para não estourar o cartão
            if (valor >= 100000) {
                return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', notation: 'compact', maximumFractionDigits: 1 });
            }
            return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
        },
        pedirSimulacao() {
            abreWhatsApp(`Olá! Pago cerca de R$ ${this.conta} por mês de energia e gostaria de uma simulação de energia solar.`, 'Simulador solar');
        }
    }
});
